// Define z-index levels to make element layering easier

export const BASE_Z_INDEX = 50;
export const FRAME_OVERLAY_Z_INDEX = BASE_Z_INDEX;
export const MODAL_Z_INDEX = FRAME_OVERLAY_Z_INDEX + 50;
export const MENU_Z_INDEX = MODAL_Z_INDEX + 50;
